import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { Box } from "@mui/material";
import {
  hasAllProjectAccess,
  hasCallHistoryAccess,
  hasCampaignsAccess,
  PAGE_SIZE_50,
} from "../../../components/NewDevelopment/CommonComponents/Common";
import {
  getAllCampaignDetailsAction,
  getCallHistoryAction,
  getCallHistoryCountAction,
  getCampaignDetailsAction,
} from "../../../components/NewDevelopment/ProjectSection/CampaignSection/Store/Campaign.action";
import CallStatusFilter from "./CallStatusFilter";
import CallTypeFilter from "./CallTypeFilter";
import DurationFilter from "./DurationFilter";
import FilterHeading from "./FilterHeading";
import DateProjectFilter from "./DateProjectFilter";
import moment1 from "moment-timezone";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import {
  getDecryptedItem,
  setEncryptedItem,
} from "../../../utils/localStorageHelper";
import { swalWarningMessage } from "../../../Constant/swalMessage";
const FilterFooter = React.lazy(() => import("./FilterFooter"));
const SavedFilters = React.lazy(() => import("./SavedFilters"));

const updateFilter = (filterArray, tag) => {
  return filterArray.includes(tag)
    ? filterArray.filter((item) => item !== tag)
    : [...filterArray, tag];
};

function FilterBody({
  obj,
  all = false,
  main = false,
  showSection = true,
  encryptionKey,
}: any) {
  const {
    searchText,
    setMainState,
    trackEnabledRecording,
    mainState,
    startDate,
    endDate,
    currentDate,
    setDateRange,
    filterName,
    setFilterName,
    setFilterNameFromDropdown,
    setSearchTerm,
    campaignId,
    projectId,
    campaignRuns,
    inBound,
    setCurrentPage,
  } = obj;
  const dispatch = useDispatch();
  const timezone = moment1.tz.guess();

  const {
    AccountReducer: { constantData, selectedAccount, accountRoles },
    ProjectReducer: { projectList },
  }: any = useSelector((state) => state);

  const hasRestrictedCallHistoryAccess =
    hasCallHistoryAccess(accountRoles) || hasCampaignsAccess(accountRoles);
  const hasAllProjectsAccess = hasAllProjectAccess(accountRoles);
  const accessedProjectIds =
    (hasRestrictedCallHistoryAccess || hasAllProjectsAccess) &&
    projectList?.map((p) => p._id);

  const allCallStatus = constantData?.callStatus;
  const [state, setState] = useState<any>({
    outComeArr: [],
    loading: false,
    saveFilter: false,
    saveDate: false,
    savedFilters: [],
  });

  const {
    durationFilter,
    statusFilter,
    callTypeFilter,
    outComefilter,
    selectedProjectId,
    min,
    max,
  } = mainState;
  const { outComeArr, loading, saveFilter, saveDate, savedFilters } = state;
  const [showAll, setShowAll] = useState(false);
  const [customDurationError, setCustomDurationError] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [localFilters, setLocalFilters] = useState({});

  let arraMapped: any = [
    {
      title: "Filter Calls with duration",
      innerMap: ["0-15 sec", "15-30 sec", "30-45 sec", "45+ sec", "Custom"],
      valueAssigned: "durationFilter",
      title1: "Duration",
    },
  ];
  if (outComeArr?.length > 0) {
    arraMapped = [
      {
        title: "Filter Calls with outcome",
        isObject: true,
        innerMap: outComeArr,
        valueAssigned: "outComefilter",
        title1: "outcome",
      },
      ...arraMapped,
    ];
  }

  useEffect(() => {
    if (
      (hasAllProjectsAccess || hasRestrictedCallHistoryAccess) &&
      projectList?.length > 0
    ) {
      setMainState((prev) => ({
        ...prev,
        selectedProjectId: projectList?.map((p) => p._id),
      }));
    }
  }, [projectList, selectedProjectId, setMainState]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      outComeArr: trackEnabledRecording,
    }));
  }, [trackEnabledRecording]);

  useEffect(() => {
    const savedFilterData =
      getDecryptedItem("savedFilterData") === undefined
        ? []
        : getDecryptedItem("savedFilterData");
    setState((prev) => ({
      ...prev,
      savedFilters: savedFilterData,
    }));

    const appliedFilters = getDecryptedItem(encryptionKey) || {};
    setLocalFilters(appliedFilters);
  }, []);

  const handleApplyFilter = async (scenario = "apply") => {
    if (
      statusFilter?.length === 0 &&
      callTypeFilter?.length === 0 &&
      !durationFilter &&
      selectedProjectId?.length === 0 &&
      (!main || (main && (!startDate || !endDate)))
    ) {
      swalWarningMessage("Please select at least one filter");
      return;
    }
    if (scenario === "locApply" && !filterName.trim()) {
      setErrMsg("Please enter a filter name.");
      return;
    }
    if (!validateDurationFilter()) return;

    const customDuration = durationFilter === "Custom" ? `${min}-${max}` : "";
    setState((prev) => ({ ...prev, loading: true }));

    const requestObj = {
      pageIndex: 1,
      pageSize: PAGE_SIZE_50,
      live: false,
      duration:
        durationFilter === "Custom"
          ? customDuration
          : durationFilter?.split(" ")[0],
      searchText,
      callStatus: statusFilter,
      callType: inBound ? "INBOUND" : callTypeFilter,
      outcome: outComefilter,
    };

    const appliedFilters = {
      filterName,
      startDate,
      endDate,
      selectedProjectId,
      outComefilter,
      durationFilter,
      statusFilter,
      callTypeFilter,
      customFilter: customDuration,
    };
    if (main) {
      if (scenario === "apply") {
        const accountFilters = {
          ...localFilters,
          [selectedAccount?._id]: appliedFilters,
        };

        setEncryptedItem(encryptionKey, accountFilters);
      } else if (scenario === "locApply") {
        const newFilter = {
          filterName,
          startDate,
          endDate,
          durationFilter,
          statusFilter,
          callTypeFilter,
          outComefilter,
          selectedProjectId,
          customFilter: customDuration,
        };
        const existingFilters = getDecryptedItem("savedFilterData") || [];
        const existingFilterIndex = existingFilters.findIndex(
          (filter) => filter.filterName === filterName
        );

        if (existingFilterIndex > -1) {
          existingFilters[existingFilterIndex] = newFilter;
        } else {
          existingFilters.push(newFilter);
        }

        setEncryptedItem("savedFilterData", existingFilters);
        const accountFilters = {
          ...localFilters,
          [selectedAccount?._id]: newFilter,
        };
        setEncryptedItem(encryptionKey, accountFilters);
      }

      requestObj["from"] = startDate
        ? moment(startDate).format("YYYY-MM-DD")
        : moment(currentDate).format("YYYY-MM-DD");
      requestObj["to"] = endDate
        ? moment(endDate).format("YYYY-MM-DD")
        : moment(currentDate).format("YYYY-MM-DD");
      requestObj["projectId"] = selectedProjectId ? selectedProjectId : "";
      requestObj["timezone"] = timezone;

      await dispatch(getCallHistoryAction(requestObj));
      await dispatch(getCallHistoryCountAction(requestObj));
    } else {
      if (all) {
        setEncryptedItem(encryptionKey, appliedFilters);
        await dispatch(
          getAllCampaignDetailsAction(campaignId, {
            ...requestObj,
            isDocsOnly: "true",
          })
        );
        await dispatch(
          getAllCampaignDetailsAction(campaignId, {
            ...requestObj,
            isDocsOnly: false,
          })
        );
      } else {
        setEncryptedItem(encryptionKey, appliedFilters);
        const campaignsCount: any = await dispatch(
          getCampaignDetailsAction(projectId, campaignRuns, {
            ...requestObj,
            count: "true",
          })
        );
        const res: any = await dispatch(
          getCampaignDetailsAction(projectId, campaignRuns, requestObj)
        );
        if (res?.data) {
          setMainState((prev) => ({
            ...prev,
            campaignRunListData: res?.data,
            showCreateButton: true,
          }));
        }

        if (campaignsCount?.countsData?.length > 0) {
          let countsData = {};

          for (const status of campaignsCount?.countsData) {
            countsData[status._id] = status.count;
          }
          setMainState((prev) => ({
            ...prev,
            countObj: countsData,
          }));
        }
        setEncryptedItem("createButton", "true");
      }
    }

    setState((prev) => ({ ...prev, loading: false }));
    setMainState((prev) => ({
      ...prev,
      filterDrawer: false,
      pageIndex: 1,
    }));
    if (setCurrentPage) setCurrentPage(1);
  };

  const onChange = useCallback(
    (name, value) => {
      setMainState((prev) => {
        if (name === "outComefilter") {
          return {
            ...prev,
            outComefilter: updateFilter(outComefilter, value.tag),
          };
        }

        if (name === "statusFilter") {
          return {
            ...prev,
            statusFilter: updateFilter(statusFilter, value),
          };
        }

        if (name === "callTypeFilter") {
          return {
            ...prev,
            callTypeFilter: updateFilter(callTypeFilter, value),
          };
        }

        return {
          ...prev,
          [name]: value,
        };
      });
    },
    [setMainState, outComefilter, statusFilter, callTypeFilter]
  );
  const onCustomDurationChange = (e) => {
    const { name, value } = e.target;
    if (name === "max" && value && Number(value) <= 0) return;
    setCustomDurationError("");
    setMainState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const deleteFilter = async () => {
    localStorage.removeItem(encryptionKey);
    const deletedData = savedFilters
      ? savedFilters?.filter((data) => data?.filterName !== filterName)
      : [];
    setEncryptedItem("savedFilterData", deletedData);

    setFilterName("");
    let obj = {
      pageIndex: 1,
      pageSize: PAGE_SIZE_50,
      live: false,
      duration: "",
      callStatus: [],
      outcome: [],
      projectId: accessedProjectIds?.length > 0 ? accessedProjectIds : "",
      from: moment(currentDate).format("YYYY-MM-DD"),
      to: moment(currentDate).format("YYYY-MM-DD"),
      timezone,
      callType: inBound ? "INBOUND" : "",
    };

    await dispatch(getCallHistoryAction(obj));
    await dispatch(getCallHistoryCountAction(obj));

    setMainState((prev) => ({
      ...prev,
      durationFilter: "",
      outComefilter: [],
      statusFilter: [],
      callTypeFilter: [],
      min: "",
      max: "",
      startDate: currentDate,
      endDate: currentDate,
      selectedProjectId: null,
      filterName: "",
      searchText: "",
      filterDrawer: false,
      pageIndex: 1,
    }));
    setDateRange([new Date(currentDate), new Date(currentDate)]);
  };

  const clearFilter = async (val, prevPage = false) => {
    const resetFilters = () => {
      localStorage.removeItem(encryptionKey);
      localStorage.removeItem("selectedFilter");
      localStorage.removeItem("callHistorySearchTerm");
      localStorage.removeItem("createButton");
      setMainState((prev) => ({
        ...prev,
        durationFilter: "",
        outComefilter: [],
        statusFilter: [],
        callTypeFilter: [],
        min: "",
        max: "",
        startDate: currentDate,
        endDate: currentDate,
        selectedProjectId:
          accessedProjectIds?.length > 0 ? accessedProjectIds : null,
        filterName: "",
        searchText: "",
        showCreateButton: false,
      }));
      setState((prev) => ({
        saveFilter: false,
        saveDate: false,
      }));
    };

    if (saveFilter) {
      if (prevPage) {
        resetFilters();
        return;
      }
      return;
    }

    if (val === "all") {
      resetFilters();
      let obj = {
        pageIndex: 1,
        pageSize: PAGE_SIZE_50,
        live: false,
        duration: "",
        callStatus: [],
        outcome: [],
        projectId: accessedProjectIds?.length > 0 ? accessedProjectIds : "",
        callType: inBound ? "INBOUND" : "",
      };
      if (main) {
        setDateRange([new Date(currentDate), new Date(currentDate)]);
        setSearchTerm("");
        if (setCurrentPage) setCurrentPage(1);
        obj["from"] = moment(currentDate).format("YYYY-MM-DD");
        obj["to"] = moment(currentDate).format("YYYY-MM-DD");
        obj["timezone"] = timezone;
        await dispatch(getCallHistoryAction(obj));
        await dispatch(getCallHistoryCountAction(obj));
      } else {
        if (all) {
          await dispatch(
            getAllCampaignDetailsAction(campaignId, {
              ...obj,
              isDocsOnly: "true",
            })
          );
          await dispatch(
            getAllCampaignDetailsAction(campaignId, {
              ...obj,
              isDocsOnly: false,
            })
          );
        } else {
          const campaignsCount: any = await dispatch(
            getCampaignDetailsAction(projectId, campaignRuns, {
              ...obj,
              count: "true",
            })
          );
          const res: any = await dispatch(
            getCampaignDetailsAction(projectId, campaignRuns, obj)
          );
          if (res?.data) {
            setMainState((prev) => ({
              ...prev,
              campaignRunListData: res?.data,
            }));
          }

          if (campaignsCount?.countsData?.length > 0) {
            let countsData = {};

            for (const status of campaignsCount?.countsData) {
              countsData[status._id] = status.count;
            }
            setMainState((prev) => ({
              ...prev,
              countObj: countsData,
            }));
          }
        }
      }

      setMainState((prev) => ({
        ...prev,
        filterDrawer: false,
        pageIndex: 1,
        filterName: "",
      }));
      return;
    }

    const resetValues =
      val === "outComefilter" ||
      val === "statusFilter" ||
      val === "callTypeFilter"
        ? []
        : "";
    const filterMapping = {
      durationFilter: "duration",
      statusFilter: "callStatus",
      callTypeFilter: "callType",
      outComefilter: "outcome",
    };

    const obj = {
      pageIndex: 1,
      pageSize: PAGE_SIZE_50,
      live: false,
      duration:
        durationFilter === "Custom"
          ? `${min}-${max}`
          : durationFilter?.split(" ")[0],
      searchText: "",
      callStatus: statusFilter,
      callType: callTypeFilter,
      outcome: outComefilter,
      projectId:
        accessedProjectIds?.length > 0
          ? accessedProjectIds
          : selectedProjectId
          ? selectedProjectId
          : "",
      from: moment(currentDate).format("YYYY-MM-DD"),
      to: moment(currentDate).format("YYYY-MM-DD"),
      timezone,
    };

    delete obj[filterMapping[val]];

    if (main) {
      setSearchTerm("");
      setDateRange([new Date(currentDate), new Date(currentDate)]);

      obj["from"] = moment(currentDate).format("YYYY-MM-DD");
      obj["to"] = moment(currentDate).format("YYYY-MM-DD");
      obj["timezone"] = timezone;
      await dispatch(getCallHistoryAction(obj));
      await dispatch(getCallHistoryCountAction(obj));
    } else {
      if (all) {
        await dispatch(
          getAllCampaignDetailsAction(campaignId, {
            ...obj,
            isDocsOnly: "true",
          })
        );
        await dispatch(
          getAllCampaignDetailsAction(campaignId, {
            ...obj,
            isDocsOnly: false,
          })
        );
      } else {
        const campaignsCount: any = await dispatch(
          getCampaignDetailsAction(projectId, campaignRuns, {
            ...obj,
            count: "true",
          })
        );
        const res: any = await dispatch(
          getCampaignDetailsAction(projectId, campaignRuns, obj)
        );
        if (res?.data) {
          setMainState((prev) => ({
            ...prev,
            campaignRunListData: res?.data,
          }));
        }

        if (campaignsCount?.countsData?.length > 0) {
          let countsData = {};

          for (const status of campaignsCount?.countsData) {
            countsData[status._id] = status.count;
          }
          setMainState((prev) => ({
            ...prev,
            countObj: countsData,
          }));
        }
      }
    }

    setMainState((prev) => ({
      ...prev,
      [val]: resetValues,
      pageIndex: 1,
    }));
  };

  const validateDurationFilter = () => {
    if (durationFilter === "Custom") {
      if (!min?.trim() || !max?.trim()) {
        const errorMessage = !min?.trim() ? "Add min value" : "Add max value";

        setCustomDurationError(errorMessage);
        return false;
      }
      if (parseFloat(min) > parseFloat(max)) {
        setCustomDurationError("Max value cannot be less than min value");
        return false;
      }
    }
    return true;
  };

  const handleSaveFilter = () => {
    if (validateDurationFilter()) {
      setState((prev) => ({
        ...prev,
        saveFilter: true,
        saveDate: true,
      }));
      setFilterName("");
    }
  };

  const handleClearDurationFilter = () => {
    setMainState((prev) => ({
      ...prev,
      durationFilter: "",
      min: "",
      max: "",
    }));
    setCustomDurationError("");
  };

  const handleFilterSelect = (e) => {
    setFilterName(e.filterName);
    setFilterNameFromDropdown(e.filterName);
    const obj = {
      searchText,
      startDate: e.startDate,
      endDate: e.endDate,
      durationFilter: e.durationFilter,
      statusFilter: e.statusFilter,
      callTypeFilter: e.callTypeFilter,
      outComefilter: e.outComefilter,
      selectedProjectId: e.selectedProjectId,
      filterName: e.filterName,
      customFilter: e.customFilter,
      min: e.customFilter.split("-")[0] || "",
      max: e.customFilter.split("-")[1] || "",
    };
    const accountFilters = {
      ...localFilters,
      [selectedAccount?._id]: obj,
    };

    setEncryptedItem(encryptionKey, accountFilters);
    const params = {
      pageIndex: 1,
      pageSize: PAGE_SIZE_50,
      live: false,
      duration:
        e.durationFilter === "Custom" ? e.customFilter : e.durationFilter,
      searchText,
      from: e.startDate
        ? moment(e.startDate).format("YYYY-MM-DD")
        : moment(currentDate).format("YYYY-MM-DD"),
      to: e.endDate
        ? moment(e.endDate).format("YYYY-MM-DD")
        : moment(currentDate).format("YYYY-MM-DD"),
      projectId: e.selectedProjectId ? [e.selectedProjectId] : "",
      callStatus: e.statusFilter,
      callType: e.callTypeFilter,
      outcome: e.outComefilter,
      timezone,
    };
    dispatch(getCallHistoryAction(params));
    dispatch(getCallHistoryCountAction(params));
    setMainState((prev) => ({
      ...prev,
      ...obj,
      filterDrawer: false,
      pageIndex: 1,
    }));
  };

  const durationObj = {
    mainState,
    arraMapped,
    allCallStatus,
    outComefilter,
    onChange,
    onCustomDurationChange,
    customDurationError,
    handleClearDurationFilter,
  };

  const savedFilterObj = {
    mainState,
    projectList,
    durationFilter,
    setMainState,
    selectedProjectId,
    saveDate,
    startDate,
    endDate,
    setDateRange,
    setState,
    currentDate,
  };

  const statusFilterObj = {
    saveFilter,
    statusFilter,
    callTypeFilter,
    onChange,
    allCallStatus,
    showAll,
    setShowAll,
    showSection,
  };
  const headingObj = {
    filterName,
    setFilterName,
    saveFilter,
    savedFilters: state?.savedFilters,
    handleFilterSelect,
    errMsg,
    setErrMsg,
    deleteFilter,
    showSection,
  };

  const dateObj = {
    startDate,
    endDate,
    setDateRange,
    selectedProjectId,
    setMainState,
    projectList,
    hasRestrictedCallHistoryAccess,
    hasAllProjectsAccess,
  };

  const footerObj = {
    loading,
    saveFilter,
    handleApplyFilter,
    clearFilter,
    handleSaveFilter,
    showSection,
  };

  return (
    <Box
      className="flex-column-between"
      sx={[
        {
          height: "100%",
          padding: "17px 23px 0 23px",
        },
        commonStyles.hideScroll,
      ]}
    >
      <span style={{ fontSize: "14px", fontWeight: 600 }}>Apply Filters</span>
      <Box
        sx={[
          {
            flex: 1,
            overflowY: "auto",
            minWidth: "353px",
          },
          commonStyles.hideScroll,
        ]}
      >
        {/* <FilterHeading obj={headingObj} /> */}
        {saveFilter ? (
          <SavedFilters obj={savedFilterObj} />
        ) : (
          <>
            {showSection && <DateProjectFilter obj={dateObj} />}
            <DurationFilter obj={durationObj} />
          </>
        )}
        <CallStatusFilter obj={statusFilterObj} />
        <CallTypeFilter obj={statusFilterObj} />
      </Box>
      <FilterFooter obj={footerObj} />
    </Box>
  );
}

export default FilterBody;
